import { createSelector } from "reselect";

const selectToast = (state) => state.toast;

export const selectToastMessage = createSelector(
  [selectToast],
  (toast) => toast
);
